import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllAudiences } from '../../api/audience';
import { getAllComplexFilters } from '../../api/complexFilters';
console.log('👀 After import, getAllAudiences available:', typeof getAllAudiences);

const AudienceIndex = () => {
  console.log('🔍 AudienceIndex component rendering');
  const navigate = useNavigate();
  const [audiences, setAudiences] = useState([]);
  const [complexFilters, setComplexFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedAudienceId, setSelectedAudienceId] = useState(null);
  const [selectedComplexFilterSlug, setSelectedComplexFilterSlug] = useState(null);

  useEffect(() => {
    console.log("👀 useEffect in AudienceIndex triggered...");
    const fetchData = async () => {
      try {
        const [audienceList, complexFilterList] = await Promise.all([
          getAllAudiences(),
          getAllComplexFilters()
        ]);
        setAudiences(audienceList || []);
        setComplexFilters(complexFilterList || []);
      } catch (err) {
        console.error('❌ Failed to fetch audiences or complex filters:', err);
        setError('Failed to load audiences or complex filters.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSelectAudience = (audienceId) => {
    setSelectedAudienceId(audienceId);
    setSelectedComplexFilterSlug(null);
  };

  const handleSelectComplexFilter = (slug) => {
    setSelectedComplexFilterSlug(slug);
    setSelectedAudienceId(null);
  };

  const handleCreateAudience = () => {
    navigate('/audience/create');
  };

  if (loading) return <div>Loading audiences...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Audience Library</h1>
      <button
        onClick={handleCreateAudience}
        style={{
          marginBottom: '1rem',
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          cursor: 'pointer',
          backgroundColor: '#5c6bc0',
          color: 'white',
          borderRadius: '4px',
          border: 'none',
        }}
      >
        + Create New Audience
      </button>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
        {audiences.map((audience) => (
          <div
            key={audience.id}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '1rem',
              width: '250px',
              boxShadow: '2px 2px 6px rgba(0,0,0,0.1)',
              backgroundColor: '#fff',
              cursor: 'pointer',
              transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
            }}
          >
            <h3>{audience.filter_name}</h3>
            <p><strong>Visibility:</strong> {audience.visibility}</p>
            <p><strong>Created At:</strong> {new Date(audience.created_at).toLocaleDateString()}</p>
            <button
              onClick={() => handleSelectAudience(audience.id)}
              style={{
                marginTop: '0.5rem',
                backgroundColor: '#5c6bc0',
                color: 'white',
                borderRadius: '4px',
                border: 'none',
                padding: '0.5rem 1rem',
                cursor: 'pointer',
              }}
            >
              View / Edit
            </button>
            {selectedAudienceId === audience.id && (
              <p style={{ color: '#3f51b5', fontWeight: 'bold' }}>Currently Selected</p>
            )}
          </div>
        ))}
      </div>

      {/* System Complex Filters Section */}
      <h2>System Complex Filters</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
        {complexFilters.map((filter) => (
          <div
            key={filter.slug}
            onClick={() => handleSelectComplexFilter(filter.slug)}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '1rem',
              width: '250px',
              boxShadow: '2px 2px 6px rgba(0,0,0,0.1)',
              backgroundColor: selectedComplexFilterSlug === filter.slug ? '#e3e6ff' : '#f5f5f5',
              cursor: 'pointer',
            }}
          >
            <h3>{filter.name}</h3>
            <p>{filter.description}</p>
            <p><strong>Slug:</strong> {filter.slug}</p>
            {selectedComplexFilterSlug === filter.slug && (
              <p style={{ color: '#3f51b5', fontWeight: 'bold' }}>Currently Selected</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AudienceIndex;